import React from 'react';

export default (props) => {
  return (
    <div
      data-testid="local-dev"
      id={props.name}
    />
  );
};
